/*
 * Generated by tutor-mfe for all.
 *
 * Frontend-base counterpart of the legacy env.config.jsx.
 */

import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';

import { getConfig } from '@edx/frontend-platform';
import { Icon } from '@openedx/paragon';
import { Nightlight, WbSunny } from '@openedx/paragon/icons';
import { useIntl } from '@edx/frontend-platform/i18n';

import { DIRECT_PLUGIN, IFRAME_PLUGIN, PLUGIN_OPERATIONS } from '@openedx/frontend-plugin-framework';

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }
  config.pluginSlots[slot_name].plugins.push(...plugins);
}
let themeVariant = 'selected-paragon-theme-variant';

const AddDarkTheme = () => {
  const isThemeToggleEnabled = getConfig().INDIGO_ENABLE_DARK_TOGGLE;

  const addDarkThemeToIframes = () => {
    const iframes = document.getElementsByTagName('iframe');
    const iframesLength = iframes.length;
    if (iframesLength > 0) {
      Array.from({ length: iframesLength }).forEach((_, index) => {
        const style = document.createElement('style');
        style.textContent = `
          body {
            background-color: #0D0D0E;
            color: #ccc;
          }
          a { color: #ccc; }
          a:hover { color: #d3d3d3; }
        `;
        if (iframes[index].contentDocument) {
          iframes[index].contentDocument.head.appendChild(style);
        }
      });
    }
  };

  useEffect(() => {
    const storedTheme = window.localStorage.getItem(themeVariant);
    const theme = storedTheme && storedTheme !== 'undefined' ? storedTheme : 'light';

    // - When page loads, Footer loads before MFE content. Since there is no iframe on page,
    // it does not append any class. MutationObserver observes changes in DOM and hence appends dark
    // attributes when iframe is added. After 15 sec, this observer is destroyed to conserve resources. 
    // - It has been added outside dark-theme condition so that it can be removed on Component Unmount.
    // - Observer can be passed to `addDarkThemeToIframes` function and disconnected after observing Iframe.
    // This approach has a limitation: the observer first detects the iframe and then detects the docSrc. 
    // We need to wait for docSrc to fully load before appending the style tag.
    const observer = new MutationObserver(() => {
      addDarkThemeToIframes();
    });

    document.documentElement.setAttribute('data-paragon-theme-variant', theme);

    if (isThemeToggleEnabled && theme === 'dark') {
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer?.disconnect(), 15000); // clear after 15 sec to avoid resource usage
    }

    return () => observer?.disconnect();
  }, []);

  return (<div />);
};

function setConfig() {
  const config = {
    pluginSlots: {},
  };const IndigoFooter = () => {
  const intl = useIntl();
  const config = getConfig();
  const baseUrl = config.LMS_BASE_URL;
  const aboutUrl = new URL("/about", baseUrl).toString();
  const year = new Date().getFullYear();

  const messages = {
    "footer.poweredby.text": {
      id: "footer.poweredby.text",
      defaultMessage: "Powered by",
      description: "text for the footer",
    },
    "footer.tutorlogo.altText": {
      id: "footer.tutorlogo.altText",
      defaultMessage: "Runs on Tutor",
      description: "alt text for the footer tutor logo",
    },
    "footer.logo.altText": {
      id: "footer.logo.altText",
      defaultMessage: "Powered by Open edX",
      description: "alt text for the footer logo.",
    },
    "footer.about.title": {
      id: "footer.about.title",
      defaultMessage: "About",
      description: "footer about column title",
    },
    "footer.about.sandbox": {
      id: "footer.about.sandbox",
      defaultMessage: "About the Open edX sandbox",
      description: "footer link text for sandbox about page",
    },
    "footer.about.project": {
      id: "footer.about.project",
      defaultMessage: "About the Open edX project",
      description: "footer link text for project about page",
    },
    "footer.about.conduct": {
      id: "footer.about.conduct",
      defaultMessage: "Code of conduct",
      description: "footer link text for code of conduct",
    },
    "footer.community.title": {
      id: "footer.community.title",
      defaultMessage: "Join our community",
      description: "footer community column title",
    },
    "footer.community.workingGroups": {
      id: "footer.community.workingGroups",
      defaultMessage: "Working Groups",
      description: "footer link text for working groups",
    },
    "footer.community.marketplace": {
      id: "footer.community.marketplace",
      defaultMessage: "Marketplace",
      description: "footer link text for marketplace",
    },
    "footer.help.title": {
      id: "footer.help.title",
      defaultMessage: "Help",
      description: "footer help column title",
    },
    "footer.help.sandbox": {
      id: "footer.help.sandbox",
      defaultMessage: "Sandbox",
      description: "footer link text for sandbox home",
    },
    "footer.help.contact": {
      id: "footer.help.contact",
      defaultMessage: "Contact Us",
      description: "footer link text for contact us",
    },
    "footer.abstract.altText": {
      id: "footer.abstract.altText",
      defaultMessage: "Abstract Technology GmbH",
      description: "alt text for abstract logo",
    },
    "footer.abstract.description": {
      id: "footer.abstract.description",
      defaultMessage:
        "Abstract Technology GmbH is a verified service provider, dedicated to supporting and maintaining this Open edX sandbox.",
      description: "footer description for abstract technology",
    },
    "footer.termsOfUseAnd": {
      id: "footer.termsOfUseAnd",
      defaultMessage: "Terms of Use and",
      description: "footer lower link text for terms",
    },
    "footer.privacyPolicy": {
      id: "footer.privacyPolicy",
      defaultMessage: "Privacy Policy",
      description: "footer lower link text for privacy policy",
    },
    "footer.trademarkLicensing": {
      id: "footer.trademarkLicensing",
      defaultMessage: "Trademark / Licensing Details",
      description:
        "footer lower link text for trademark and licensing details",
    },
    "footer.aximCopyright": {
      id: "footer.aximCopyright",
      defaultMessage:
        "© {year} Axim Collaborative, Inc. All Rights Reserved.",
      description: "footer copyright text",
    },
    "footer.social.facebook": {
      id: "footer.social.facebook",
      defaultMessage: "Open edX on Facebook",
      description: "alt text for facebook footer icon",
    },
    "footer.social.twitter": {
      id: "footer.social.twitter",
      defaultMessage: "Open edX on X",
      description: "alt text for twitter footer icon",
    },
    "footer.social.linkedin": {
      id: "footer.social.linkedin",
      defaultMessage: "Open edX on LinkedIn",
      description: "alt text for linkedin footer icon",
    },
  };

  return (
    <div className="indigo-mfe-footer-shell">
      <footer id="footer" className="indigo-mfe-footer">
        <div className="indigo-mfe-footer__top">
          <div className="indigo-mfe-footer__brand">
            <ul className="indigo-mfe-footer__logo-list">
              <li>
                <a
                  href="https://open.edx.org"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    className="indigo-mfe-footer__logo indigo-mfe-footer__logo--openedx indigo-mfe-footer__asset indigo-mfe-footer__asset--light"
                    src={`${baseUrl}/static/indigo/images/openedx-logo.png`}
                    alt={intl.formatMessage(
                      messages["footer.logo.altText"],
                    )}
                  />
                  <img
                    className="indigo-mfe-footer__logo indigo-mfe-footer__logo--openedx indigo-mfe-footer__asset indigo-mfe-footer__asset--dark"
                    src={`${baseUrl}/static/indigo/images/openedx-logo-dark.png`}
                    alt={intl.formatMessage(
                      messages["footer.logo.altText"],
                    )}
                  />
                </a>
              </li>
            </ul>
          </div>

          <nav
            className="indigo-mfe-footer__nav"
            aria-label={intl.formatMessage(
              messages["footer.about.title"],
            )}
          >
            <ol>
              <li>
                <ul className="indigo-mfe-footer__link-group">
                  <li className="indigo-mfe-footer__group-title">
                    {intl.formatMessage(
                      messages["footer.about.title"],
                    )}
                  </li>
                  <li>
                    <a href={aboutUrl} rel="noreferrer" target="_blank">
                      {intl.formatMessage(
                        messages["footer.about.sandbox"],
                      )}
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://openedx.org/about-open-edx/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      {intl.formatMessage(
                        messages["footer.about.project"],
                      )}
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://openedx.org/code-of-conduct/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      {intl.formatMessage(
                        messages["footer.about.conduct"],
                      )}
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="indigo-mfe-footer__link-group">
                  <li className="indigo-mfe-footer__group-title">
                    {intl.formatMessage(
                      messages["footer.community.title"],
                    )}
                  </li>
                  <li>
                    <a
                      href="https://openedx.org/community/the-open-edx-technical-oversight-committee/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      TOC
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://openedx.org/open-edx-community-working-groups/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      {intl.formatMessage(
                        messages["footer.community.workingGroups"],
                      )}
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://openedx.org/marketplace-all/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      {intl.formatMessage(
                        messages["footer.community.marketplace"],
                      )}
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="indigo-mfe-footer__link-group">
                  <li className="indigo-mfe-footer__group-title">
                    {intl.formatMessage(
                      messages["footer.help.title"],
                    )}
                  </li>
                  <li>
                    <a
                      href="https://sandbox.openedx.org/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      {intl.formatMessage(
                        messages["footer.help.sandbox"],
                      )}
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://openedx.org/community/connect/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      {intl.formatMessage(
                        messages["footer.help.contact"],
                      )}
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="indigo-mfe-footer__link-group">
                  <li className="indigo-mfe-footer__group-title">
                    <a
                      href="https://abstract-technology.de/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <img
                        className="indigo-mfe-footer__logo indigo-mfe-footer__logo--abstract indigo-mfe-footer__asset indigo-mfe-footer__asset--light"
                        src={`${baseUrl}/static/indigo/images/abstract-logo.png`}
                        alt={intl.formatMessage(
                          messages["footer.abstract.altText"],
                        )}
                      />
                      <img
                        className="indigo-mfe-footer__logo indigo-mfe-footer__logo--abstract indigo-mfe-footer__asset indigo-mfe-footer__asset--dark"
                        src={`${baseUrl}/static/indigo/images/abstract-logo-dark.png`}
                        alt={intl.formatMessage(
                          messages["footer.abstract.altText"],
                        )}
                      />
                    </a>
                  </li>
                  <li className="indigo-mfe-footer__company-text">
                    {intl.formatMessage(
                      messages["footer.abstract.description"],
                    )}
                  </li>
                </ul>
              </li>
            </ol>
          </nav>
        </div>

        <div className="indigo-mfe-footer__bottom">
          <div>
            <div className="indigo-mfe-footer__legal-links">
              <a
                href="https://openedx.org/terms-of-use/"
                rel="noreferrer"
                target="_blank"
              >
                {intl.formatMessage(messages["footer.termsOfUseAnd"])}
              </a>
              <a
                href="https://openedx.org/privacy-policy/"
                rel="noreferrer"
                target="_blank"
              >
                {intl.formatMessage(messages["footer.privacyPolicy"])}
              </a>
              <a
                href="https://openedx.org/trademark-licensing-details/"
                rel="noreferrer"
                target="_blank"
              >
                {intl.formatMessage(
                  messages["footer.trademarkLicensing"],
                )}
              </a>
            </div>

            <span className="indigo-mfe-footer__copyright">
              {intl.formatMessage(messages["footer.aximCopyright"], {
                year,
              })}
            </span>
          </div>

          <div className="indigo-mfe-footer__socials">
            <a
              href="https://www.facebook.com/openedX"
              rel="noreferrer"
              target="_blank"
            >
              <img
                className="indigo-mfe-footer__social-icon indigo-mfe-footer__social-icon--facebook indigo-mfe-footer__asset indigo-mfe-footer__asset--light"
                src={`${baseUrl}/static/indigo/images/facebook.svg`}
                alt={intl.formatMessage(
                  messages["footer.social.facebook"],
                )}
              />
              <img
                className="indigo-mfe-footer__social-icon indigo-mfe-footer__social-icon--facebook indigo-mfe-footer__asset indigo-mfe-footer__asset--dark"
                src={`${baseUrl}/static/indigo/images/facebook-dark.svg`}
                alt={intl.formatMessage(
                  messages["footer.social.facebook"],
                )}
              />
            </a>
            <a
              href="https://twitter.com/OpenEdX"
              rel="noreferrer"
              target="_blank"
            >
              <img
                className="indigo-mfe-footer__social-icon indigo-mfe-footer__social-icon--twitter indigo-mfe-footer__asset indigo-mfe-footer__asset--light"
                src={`${baseUrl}/static/indigo/images/twitter.svg`}
                alt={intl.formatMessage(
                  messages["footer.social.twitter"],
                )}
              />
              <img
                className="indigo-mfe-footer__social-icon indigo-mfe-footer__social-icon--twitter indigo-mfe-footer__asset indigo-mfe-footer__asset--dark"
                src={`${baseUrl}/static/indigo/images/twitter-dark.svg`}
                alt={intl.formatMessage(
                  messages["footer.social.twitter"],
                )}
              />
            </a>
            <a
              href="https://www.linkedin.com/company/openedx/"
              rel="noreferrer"
              target="_blank"
            >
              <img
                className="indigo-mfe-footer__social-icon indigo-mfe-footer__social-icon--linkedin indigo-mfe-footer__asset indigo-mfe-footer__asset--light"
                src={`${baseUrl}/static/indigo/images/linkedin-in.svg`}
                alt={intl.formatMessage(
                  messages["footer.social.linkedin"],
                )}
              />
              <img
                className="indigo-mfe-footer__social-icon indigo-mfe-footer__social-icon--linkedin indigo-mfe-footer__asset indigo-mfe-footer__asset--dark"
                src={`${baseUrl}/static/indigo/images/linkedin-in-dark.svg`}
                alt={intl.formatMessage(
                  messages["footer.social.linkedin"],
                )}
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};const homePageOverlayMessages = {
  title: {
    id: 'catalog.home-page.title',
    defaultMessage: 'Explore the Open edX® Platform running on the <highlight>Verawood release</highlight>.<lineBreak></lineBreak>No setup, no commitment - just start testing.',
    description: 'Title shown in the catalog home page overlay.',
  },
};

const renderHighlight = (chunks) => (
  <a
    className="home-page-overlay-release-link"
    href="https://docs.openedx.org/en/latest/community/release_notes/verawood.html"
    rel="noreferrer"
    target="_blank"
  >
    {chunks}
  </a>
);

const renderLineBreak = () => <br />;

const HomePageOverlay = () => {
  const intl = useIntl();

  return (
    <div className="title-container">
      <h1 className="display-1 text-center">
        {intl.formatMessage(homePageOverlayMessages.title, {
          highlight: renderHighlight,
          lineBreak: renderLineBreak,
        })}
      </h1>
    </div>
  );
};
const MobileViewHeader = () => {
  const config = getConfig();
  const intl = useIntl();
  const messages = {
    "mobile.view.header.logo.altText": {
      id: "mobile.view.header.logo.altText",
      defaultMessage: "My Open edX",
      description: "alt text for the mobile view header logo",
    },
  };

  const BASE_URL = config.LMS_BASE_URL;

  return (
    <>
      <style>
        {`
          #root .logo-image.logo-white {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root .logo-image {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root .logo-white {
            display: block;
          }
        `}
      </style>
      <a href={`${BASE_URL}/dashboard`} title="Open edX" className="logo">
        <img className="logo-image" src={`${BASE_URL}/static/indigo/images/logo.png`} alt={intl.formatMessage(messages["mobile.view.header.logo.altText"])} />
        <img className="logo-image logo-white" src={`${BASE_URL}/static/indigo/images/logo-white.png`} alt={intl.formatMessage(messages["mobile.view.header.logo.altText"])} />
      </a>
    </>
  );
};const studioBannerMessages = {
  "studioBanner.title": {
    id: "studioBanner.title",
    defaultMessage:
      "Discover the Open edX Authoring Tool Studio running on Verawood!",
    description: "heading text for the learner dashboard studio banner",
  },
  "studioBanner.description": {
    id: "studioBanner.description",
    defaultMessage:
      "Explore the features and tools the Open edX Studio offers in the <highlight>Verawood release</highlight> for creating engaging and impactful online courses.",
    description: "description text for the learner dashboard studio banner",
  },
  "studioBanner.cta": {
    id: "studioBanner.cta",
    defaultMessage: "Studio",
    description: "call to action label for the learner dashboard studio banner",
  },
};

const renderReleaseLink = (chunks) => (
  <a
    className="studio-banner-release-link"
    href="https://docs.openedx.org/en/latest/community/release_notes/verawood.html"
    target="_blank"
  >
    {chunks}
  </a>
);

const StudioBanner = () => {
  const intl = useIntl();

  return (
    <>
      <div className="studio-banner">
        <div className="studio-banner-text">
          <h2>{intl.formatMessage(studioBannerMessages["studioBanner.title"])}</h2>
          <p>
            {intl.formatMessage(studioBannerMessages["studioBanner.description"], {
              highlight: renderReleaseLink,
            })}
          </p>
        </div>
        <a
          className="studio-btn btn btn-primary"
          href={`${getConfig().STUDIO_BASE_URL}/home`}
        >
          {intl.formatMessage(studioBannerMessages["studioBanner.cta"])}
        </a>
      </div>
    </>
  );
};
const ThemedLogo = () => {
  const BASE_URL = getConfig().LMS_BASE_URL;

  return (
    <>
      <style>
        {`
          #root header .logo-image.logo-white {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root header .logo-image {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root header .logo-white {
            display: block;
          }
        `}
      </style>
      <a href={`${BASE_URL}/dashboard`} title="Open edX" className="logo">
        <img className="logo-image" src={`${BASE_URL}/static/indigo/images/logo.png`} alt="Open edX" />
        <img className="logo-image logo-white" src={`${BASE_URL}/static/indigo/images/logo-white.png`} alt="Open edX" />
      </a>
    </>
  );
};
const ToggleThemeButton = () => {
  const intl = useIntl();
  const [isDarkThemeEnabled, setIsDarkThemeEnabled] = useState(false);

  const themeCookieNames = [
    'selected-paragon-theme-variant',
    'selected-theme-variant',
  ];
  const themeAttributeNames = [
    'data-paragon-theme-variant',
    'data-theme-variant',
  ];
  const primaryCookie = themeCookieNames[0];
  const themeCookieExpiry = 90; // days
  const isThemeToggleEnabled = getConfig().INDIGO_ENABLE_DARK_TOGGLE;

  const getCookie = (name) => {
    return document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="))
      ?.split("=")[1];
  };

  const getThemeCookie = () => {
    for (const name of themeCookieNames) {
      const value = getCookie(name);
      if (value !== undefined) {
        return value;
      }
    }
    return undefined;
  };

  const resolveTheme = (value) => {
    if (!value || value === 'undefined') {
      return 'light';
    }
    return value;
  };

  const setCookie = (name, value, { domain, path, expires }) => {
    document.cookie = `${name}=${value}; domain=${domain}; path=${path}; expires=${expires.toUTCString()}; SameSite=Lax`;
  };

  const setThemeCookies = (value, opts) => {
    for (const name of themeCookieNames) {
      setCookie(name, value, opts);
    }
  };
  const setThemeAttribute = (theme) => {
    for (const attr of themeAttributeNames) {
      document.documentElement.setAttribute(attr, theme);
    }
  };

  const serverURL = new URL(getConfig().LMS_BASE_URL);

  const getCookieExpiry = () => {
    const today = new Date();
    return new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + themeCookieExpiry
    );
  };

  const getCookieOptions = (serverURL) => ({
    domain: serverURL.hostname,
    path: '/',
    expires: getCookieExpiry(),
  });

  const onToggleTheme = () => {
    let theme = '';

    if (resolveTheme(getThemeCookie()) === 'dark') {
      setThemeAttribute('light');
      setIsDarkThemeEnabled(false);
      theme = 'light';
    } else {
      setThemeAttribute('dark');
      setIsDarkThemeEnabled(true);
      theme = 'dark';
    }

    for (const name of themeCookieNames) {
        window.localStorage.setItem(name, theme);
    }
    setTimeout(() => {
      setThemeCookies(theme, getCookieOptions(serverURL));
      window.location.reload();
    }, 1);
  };

  useEffect(() => {
    const cookie = resolveTheme(getThemeCookie());
    if (cookie !== resolveTheme(window.localStorage.getItem(primaryCookie))) {
      for (const name of themeCookieNames) {
        window.localStorage.setItem(name, cookie);
      }
      window.location.reload();
    }
    document.documentElement.setAttribute(themeAttributeNames[0], cookie);
  }, []);

  const handleKeyUp = (event) => {
    if (event.key === "Enter") {
      onToggleTheme();
    }
  };

  if (!isThemeToggleEnabled) {
    return <div />;
  }

  const messages = {
    "header.user.theme": {
      id: "header.user.theme",
      defaultMessage: "Toggle Theme",
      description: "Toggle between light and dark theme",
    },
  };

  return (
    <div className="theme-toggle-button mr-3">
      <div className="light-theme-icon">
        <Icon src={WbSunny} />
      </div>
      <div className="toggle-switch">
        <label htmlFor="theme-toggle-checkbox" className="switch">
          <input
            id="theme-toggle-checkbox"
            defaultChecked={resolveTheme(getThemeCookie()) === 'dark'}
            onChange={onToggleTheme}
            onKeyUp={handleKeyUp}
            type="checkbox"
            title={intl.formatMessage(messages["header.user.theme"])}
          />
          <span className="slider round" />
          <span id="theme-label" className="sr-only">{`Switch to ${isDarkThemeEnabled ? "Light" : "Dark"
            } Mode`}</span>
        </label>
      </div>
      <div className="dark-theme-icon">
        <Icon src={Nightlight} />
      </div>
    </div>
  );
};

      config.SIDEBAR_WIDGETS = [
        ...(config.SIDEBAR_WIDGETS || []),
        { id: 'UPGRADE', enabled: false },
      ];
        
  addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'indigo_footer',
            type: DIRECT_PLUGIN,
            priority: 1,
            RenderWidget: IndigoFooter,
        },
    },
]);
  addPlugins(config, 'desktop_secondary_menu_slot', [
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'theme_switch_button',
            type: DIRECT_PLUGIN,
            RenderWidget: ToggleThemeButton,
        },
    },
]);
  addPlugins(config, 'mobile_header_slot', [
    {
        op: PLUGIN_OPERATIONS.Hide,
        widgetId: 'default_contents',
    },
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'theme_switch_button',
            type: DIRECT_PLUGIN,
            RenderWidget: MobileViewHeader,
        },
    },
]);
  addPlugins(config, 'logo_slot', [
    {
        op: PLUGIN_OPERATIONS.Hide,
        widgetId: 'default_contents',
    },
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'custom_logo',
            type: DIRECT_PLUGIN,
            RenderWidget: ThemedLogo,
        }
    }
]);
if (config.pluginSlots && config.pluginSlots['logo_slot']) {
  config.pluginSlots['logo_slot'].keepDefault = false;

  const logoInsertPlugins =
    config.pluginSlots['logo_slot'].plugins.filter(plugin => plugin.op === 'insert' && plugin.widget?.id === 'custom_logo');

  if (logoInsertPlugins.length > 1) {
    let kept = false;
    config.pluginSlots['logo_slot'].plugins =
      config.pluginSlots['logo_slot'].plugins.filter(plugin => {
        if (plugin.op === 'insert' && plugin.widget?.id === 'custom_logo') {
          if (kept) return false;
          kept = true;
        }
        return true;
      });
  }
}

if (config.pluginSlots && config.pluginSlots['org.openedx.frontend.layout.footer.v1']) {
  let keptIndigoFooter = false;
  config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins =
    config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins.filter(plugin => {
      if (plugin.op !== 'insert' || plugin.widget?.id !== 'indigo_footer') {
        return true;
      }
      if (keptIndigoFooter) {
        return false;
      }
      keptIndigoFooter = true;
      return true;
    });
}

  return config;
}

export default setConfig;